import efocats_validate_core from './efocats_validate_core.js';
import EFOcats_error_info from '../efocats_error_info.js';
/**
 * 文字数制限チェッククラス
 */
export default class EFOcats_validate_text extends efocats_validate_core {
  /**
   * エラーチェック
   */
  validate(checkData) {
    if (checkData.attr('type') !== 'text' && checkData.prop('tagName') !== 'TEXTAREA') {
      return new EFOcats_error_info('success', '', '', '');
    }

    // 正規表現オブジェクト
    const kan_extraction_pattern = new RegExp(/([\u4E00-\u9FFF])/);
    const hira_extraction_pattern = new RegExp(/[\u3041-\u3096]/);
    const en_extraction_pattern = new RegExp(/[a-zA-Z]/);
    const num_extraction_pattern = new RegExp(/[1-9１-９]/);
    const kigou_extraction_pattern = new RegExp(/[!"#$%&'()*+\-.,/:;<=>?@[\\\]^_`{|}~！＂＃＄％＆＇（）＊＋－．，／：；＜＝＞？＠＼［＼］＾＿｀｛｜｝～]/);

    if (checkData.attr('data-input') === 'output') {
      if (
        checkData.val().match(kan_extraction_pattern) ||
        checkData.val().match(hira_extraction_pattern) ||
        checkData.val().match(en_extraction_pattern) ||
        checkData.val().match(num_extraction_pattern) ||
        checkData.val().match(kigou_extraction_pattern)
      ) {
        return new EFOcats_error_info('error', this.langagerList('カタカナエラー'), '', 'カタカナエラー');
      }
    }

    return new EFOcats_error_info('success', '', '', '');
  }

  obj_remove(obj) {
    obj.addClass('hidden');
  }
}
